<template>
  <el-container class="layout">
    <!-- 侧边栏 -->
    <el-aside :width="appStore.sidebarCollapsed ? '64px' : '210px'" class="layout__aside">
      <SideMenu />
    </el-aside>

    <el-container class="layout__body">
      <!-- 顶栏 -->
      <el-header height="56px" class="layout__header">
        <HeaderBar />
      </el-header>

      <!-- 页签 -->
      <TabsBar />

      <!-- 内容区 -->
      <el-main class="layout__main">
        <router-view v-slot="{ Component, route }">
          <keep-alive :max="12">
            <component :is="Component" :key="route.fullPath" />
          </keep-alive>
        </router-view>
        <!-- 首页快捷入口 -->
        <AlarmBall />
      </el-main>
    </el-container>
  </el-container>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import SideMenu from './components/SideMenu.vue'
import HeaderBar from './components/HeaderBar.vue'
import TabsBar from './components/TabsBar.vue'
import AlarmBall from './components/AlarmBall.vue'
import { useAppStore } from '@/store/app'
import { useUserStore } from '@/store/user'

const appStore = useAppStore()
const userStore = useUserStore()

onMounted(() => {
  // 系统配置（域名、logo、版权）——旧 getSystemConfigFun 的调用时机
  userStore.loadSystemConfig()
})
</script>

<style scoped lang="scss">
.layout {
  height: 100%;

  &__aside {
    background: #1f2d3d;
    transition: width 0.2s;
    overflow: hidden;
  }

  &__body {
    height: 100%;
    overflow: hidden;
  }

  &__header {
    padding: 0;
    background: $c-bg-white;
    box-shadow: $shadow-sm;
    z-index: 10;
  }

  &__main {
    padding: 0;
    background: $c-bg;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    height: 100%;
  }
}
</style>
